import * as Config from '../../config'
import axios from 'axios'
import Logger from '@/globals/Logger'

const state = {
    isAuthenticated: !!localStorage.getItem("access_token"),
    userInfo: null,
    userInfoLoaded: false,
}

const actions = {
    login({ commit, dispatch }, data) {

        var postData = {
            client_id: 2,
            client_secret: Config.clientSecret,
            grant_type: 'password',
            username: data.email,
            password: data.password,
        }

        return axios.post(Config.apiPath + '/oauth/token', postData).then((response) => {
            commit('setAccessToken', response.data)
            dispatch('getUserInfo')
        }).catch(error => {
            Logger('error', 'Problem retrieving user information', error.response.status)
            return error.response.status
        })
    },

    getUserInfo({commit}) {

        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        return axios.get(Config.apiPath + '/api/user', header).then((response) => {

            if(Config.debugMode) Logger('info', 'User info received', response.data)

            commit('setUserInfo', response.data)

        });

    },

    logout({commit}) {
        localStorage.removeItem('access_token');
        commit('clearUserInfo')
    }
}

const mutations = {
    setAccessToken(state, data) {
        localStorage.setItem('access_token', data.access_token)
    },
    setUserInfo(state, data) {
        state.userInfo = data;
        state.userInfoLoaded = true;
        // localStorage.setItem('userInfo', data)
    },
    clearUserInfo(state) {
        state.userInfo = null
    }
}

const getters = {
    isAuthenticated: state => {
        return state.isAuthenticated
    },

    userInfo: state => {
        return state.userInfo
    },

    getAuthorizationHeader() {
        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        return header;
    },
}

export default {
    state,
    mutations,
    getters,
    actions
}
